/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { getIn } from 'formik';
import React, { useId } from 'react';

import FormError from './common/FormError';

const SelectField = (props) => {
  const {
    field,
    form,
    label,
    optionArray,
    autoComplete,
    required,
    onChange,
    onBlur,
    labelSROnly,
    displayErrors = true,
    dataTestId
  } = props;
  const { name, onChange: onFieldChange, onBlur: onFieldBlur } = field;
  const { touched, errors } = form;

  const fieldId = useId();

  const handleOnChange = (e) => {
    onFieldChange(e);
    if (onChange) {
      setTimeout(() => onChange(e), 1);
    }
  };

  const handleOnBlur = (e) => {
    onFieldBlur(e);
    if (onBlur) {
      setTimeout(() => onBlur(e), 1);
    }
  };

  const error = getIn(errors, name);
  const touch = getIn(touched, name);

  const id = `c7-${fieldId}-${name}`;
  const labelId = `${id}-label`;
  return (
    <div className="c7-form__field">
      <label
        htmlFor={id}
        id={labelId}
        className={classNames(
          required && 'c7-required',
          labelSROnly && 'c7-sr-only'
        )}
      >
        {label}
      </label>
      <select
        {...field}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        aria-required={required}
        required={required}
        name={name}
        id={id}
        aria-labelledby={labelId}
        autoComplete={autoComplete}
        aria-invalid={!!error && touch}
        data-testId={dataTestId}
      >
        <OptionArray optionArray={optionArray} />
      </select>
      {displayErrors && (
        <FormError
          touch={touch}
          error={error}
          id={`${id}-error`}
          label={label}
        />
      )}
    </div>
  );
};

export default SelectField;

const OptionArray = (props) => {
  const { optionArray } = props;
  return optionArray.map((option) => (
    <option value={option.value} key={option.value}>
      {option.option}
    </option>
  ));
};
